<template>
  <div class="info-item">
    <dt class="info-item__term">
      <slot name="title">{{ title }}</slot
      >:
    </dt>
    <dd class="info-item__details"><slot /></dd>
  </div>
</template>

<script>
export default {
  name: "ProfileTeamToolbar",
  props: {
    title: String
  }
};
</script>

<style lang="scss" scoped>
.info-item {
  font-size: 24px;
  font-weight: fw(bold);
  display: flex;

  &__term {
    color: colors(text-2);
    margin-right: 0.25em;
    flex-shrink: 0;
  }

  &__details {
    color: colors(text-4);
  }

  @include breakpoint("lg-and-down") {
    font-size: 20px;
  }

  @include breakpoint("sm-and-down") {
    font-size: 18px;
  }
}
</style>
